import LoadingButtonGeneral from '../../../../../components/general/buttons/loadingButtonGeneral';
import { PqrDetailActionsProps } from './props';
import { usePqrDetailActions } from './hook';
import { Box, Grid, Typography } from '@mui/material';
import { Dialog } from '../../../../../components/general/dialog/dialog';
import Loading from '../../../../../components/general/loadings/loading';

export const PqrDetailActions = ({ pqr, samples }: PqrDetailActionsProps) => {
    const {
        canRetrySmartActions,
        textBtnStyle,
        open,
        setOpen,
        handleClose,
        handleRetry,
        resultRetry,
        loading,
        isM1,
        isM2,
    } = usePqrDetailActions(pqr);

    return (
        <>
            {canRetrySmartActions && !samples && isM2 && (
                <LoadingButtonGeneral
                    variant="outlined"
                    title="Reintentar M2"
                    sx={{ mr: 1 }}
                    onClick={() => setOpen('M2')}
                    textSx={textBtnStyle}
                />
            )}
            {canRetrySmartActions && !samples && isM1 && (
                <LoadingButtonGeneral
                    variant="outlined"
                    title="Reintentar ACK"
                    sx={{ mr: 1 }}
                    onClick={() => setOpen('ACK')}
                    textSx={textBtnStyle}
                />
            )}

            <Dialog
                title={`Reintentar ${open === 'M2' ? 'momento 2' : 'ACK'}`}
                open={open === 'M2' || open === 'ACK'}
                onClose={handleClose}
                textSecondBtn="Aceptar"
                onClickSecondBtn={handleRetry}
            >
                <Grid
                    container
                    item
                    xs={12}
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Box
                        style={{
                            maxWidth: '500px',
                            textAlign: 'center',
                            padding: '16px',
                        }}
                    >
                        <Typography variant="h5">
                            ¿Está seguro/a de que desea reintentar el envio del{' '}
                            <strong>
                                {open === 'M2' ? 'momento 2' : 'ACK'}
                            </strong>{' '}
                            de este caso a la Super Intendencia Financiera?
                            {resultRetry?.map((item) => (
                                <>
                                    <Typography
                                        variant="h6"
                                        style={{ marginTop: '16px' }}
                                    >
                                        Tipo: {item.type}
                                    </Typography>
                                    <Typography variant="h6">
                                        Resultado: {JSON.stringify(item.result)}
                                    </Typography>
                                </>
                            ))}
                            {loading && <Loading />}
                        </Typography>
                    </Box>
                </Grid>
            </Dialog>
        </>
    );
};
